import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import SearchIcon from '@material-ui/icons/Search';
import ViewListIcon from '@material-ui/icons/ViewList';
import { Typography } from '@material-ui/core';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import {
  ColumnsPanelTrigger,
  GridToolbarFilterButton,
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
  Toolbar,
  ToolbarPropsOverrides,
} from '@mui/x-data-grid';
import { DEBOUNCE_TIME } from '../../../userManagement/constants';
import {
  SearchField,
  StyledTab,
  StyledTabs,
  ToolbarActions,
  ToolbarContainer,
  ToolbarIconButton,
  ToolbarStart,
} from './styles';
import { DiamDataGridTabs } from './types';

export interface DiamDataGridToolbarProps extends ToolbarPropsOverrides {
  title?: string;
  searchPlaceholder?: string;
  tabs?: DiamDataGridTabs;
}

export function DiamDataGridToolbar({
  title,
  searchPlaceholder,
  tabs,
}: DiamDataGridToolbarProps) {
  return (
    <Toolbar>
      <ToolbarContainer>
        <ToolbarStart>
          {title ? <Typography variant="h6">{title}</Typography> : null}
          {tabs ? (
            <StyledTabs
              aria-label={tabs.ariaLabel}
              onChange={(_event, value: string) => tabs.onChange(value)}
              value={tabs.value}
            >
              {tabs.items.map(tab => (
                <StyledTab
                  key={tab.value}
                  label={
                    <Tooltip title={tab.tooltip ?? ''}>
                      <span>{tab.label}</span>
                    </Tooltip>
                  }
                  value={tab.value}
                />
              ))}
            </StyledTabs>
          ) : null}
        </ToolbarStart>
        <ToolbarActions>
          {searchPlaceholder ? (
            <QuickFilter debounceMs={DEBOUNCE_TIME}>
              <QuickFilterControl
                render={({ ref, ...other }) => {
                  const { value, ...rest } = other;
                  return (
                    <SearchField
                      {...rest}
                      inputRef={ref}
                      aria-label="Search"
                      name="search"
                      placeholder={searchPlaceholder}
                      size="small"
                      variant="outlined"
                      value={value}
                      slotProps={{
                        htmlInput: {
                          'aria-label': searchPlaceholder,
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: value ? (
                          <InputAdornment position="end">
                            <QuickFilterClear
                              edge="end"
                              size="small"
                              aria-label="Clear search"
                            >
                              <CancelIcon fontSize="small" />
                            </QuickFilterClear>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  );
                }}
              />
            </QuickFilter>
          ) : null}
          <Tooltip title="Columns">
            <ColumnsPanelTrigger
              render={
                <ToolbarIconButton aria-label="Manage columns">
                  <ViewListIcon color="primary" />
                </ToolbarIconButton>
              }
            />
          </Tooltip>
          <GridToolbarFilterButton />
        </ToolbarActions>
      </ToolbarContainer>
    </Toolbar>
  );
}
